import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router';
import { ReactNotifications } from 'react-notifications-component';

import R from 'ramda';
import { useSelector, useDispatch } from 'react-redux';


import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import theme from "_assets/argon/theme";

import LoginPage from '_pages/LoginPage';
import RegisterPage from '_pages/RegisterPage';
import App from '_pages/App';

import { attemptGetUser } from '_store/auth';

export default function Main() {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const auth = useSelector(state => state.auth);


    useEffect(() => {
        let subscribed = true;

        dispatch(attemptGetUser())
            .then(() => subscribed && setLoading(false))
            .catch(R.identity);

        return () => { subscribed = false };
    }, [])

    return !loading && (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <ReactNotifications />
            <Routes>
                <Route exact path="/login" element={<LoginPage />} />
                <Route exact path="/register" element={<RegisterPage />} />
                <Route path="/*" element={<App />} />
            </Routes>
        </ThemeProvider>
    );
}